module.exports = __webpack_public_path__ + "static/media/ag.441882c5.svg";